import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import DonatePage from './pages/DonatePage';
import SuccessPage from './pages/SuccessPage';
import NotFoundPage from './pages/NotFoundPage';
import { ConfigProvider } from './context/ConfigContext';

// Stripe will be initialized with the publishable key from config
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '');

const App: React.FC = () => {
  return (
    <ConfigProvider>
      <Elements stripe={stripePromise}>
        <BrowserRouter>
          <Routes>
            {/* Fundraiser route (no slug) - /fundraiser/:id */}
            <Route path="/fundraiser/:fundraiserId" element={<DonatePage />} />
            {/* Program donation page: /:programSlug/:programId */}
            <Route path="/:programSlug/:programId" element={<DonatePage />} />
            {/* Success page after payment */}
            <Route path="/success" element={<SuccessPage />} />
            {/* 404 Not Found */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </Elements>
    </ConfigProvider>
  );
};

export default App;
